export const grounds = ['indigo', 'teal', 'umber', 'olive', 'oxblood', 'slate', 'plum', 'moss'] as const;
export type Ground = (typeof grounds)[number];

/**
 * The design system's deterministic ground from a title. The API computes
 * the same value (books.GroundFor), so every client agrees.
 */
export function groundFor(title: string): Ground {
  let s = 0;
  for (let i = 0; i < title.length; i++) s = (s * 31 + title.charCodeAt(i)) >>> 0;
  return grounds[s % grounds.length] as Ground;
}
